module.exports = __webpack_public_path__ + "img/logo-nav-dark.91e59a66.png";